import { Component, input, output } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { DialogSharedComponent } from '@unity/shared/presentation/dialog-shared/dialog-shared.component';

@Component({
  selector: 'unity-dialog-confirm-shared',
  standalone: true,
  imports: [KENDO_BUTTON, DialogSharedComponent],
  templateUrl: './dialog-confirm-shared.component.html',
  styleUrl: './dialog-confirm-shared.component.scss',
})
export class DialogConfirmSharedComponent {
  public confirmEvent = output();
  public closeEvent = output();

  public readonly $title = input.required<string | undefined>({ alias: 'title' });

  protected onClose(doConfirm: boolean) {
    if (doConfirm) {
      this.confirmEvent.emit();
    }
    this.closeEvent.emit();
  }
}
